import { HostBinding, inject } from '@angular/core';
import { AppVisualContextService } from 'src/app/shared/services/app-visual-context.service';
import { AppAccent } from 'src/app/core/types/app-accent.type';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { take } from 'rxjs';
import { AuthService, UsuarioExternoResponse } from 'src/app/shared/services/auth.service';
import { PopupService } from 'src/app/shared/services/popup.service';

/**
 * Primeiro acesso e "esqueci minha senha" do usuário externo: confirma CPF e e-mail do cadastro e solicita
 * o link de uso único para definir a senha, que é concluída em DefinirSenhaComponent.
 */
@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro-usuario.component.html',
  styleUrls: ['./cadastro-usuario.component.css'],
})
export class CadastroUsuarioComponent implements OnInit {
  private readonly visualContext = inject(AppVisualContextService);
  @HostBinding('class') get visualClass(): string {
    return this.accent === undefined ? '' : this.visualContext.classForAccent(this.accent);
  }

  accent: AppAccent = 'solicitacao';

  formCadastro: FormGroup;
  mensagemEnvio: string | null = null;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private popupService: PopupService
  ) {}

  ngOnInit(): void {
    this.formCadastro = this.formBuilder.group({
      cpf: ['', [Validators.required, Validators.minLength(11)]],
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submit(): void {
    if (this.formCadastro.invalid) {
      this.formCadastro.markAllAsTouched();
      this.popupService.showError('Preencha corretamente o CPF e o e-mail!');
      return;
    }

    const { cpf, email } = this.formCadastro.value;
    const body = JSON.stringify({ cpf, email });

    this.authService
      .solicitarSenhaExterno({ body, spinnerDelay: 300 })
      .pipe(take(1))
      .subscribe({
        // Endpoint do módulo Externo do ws: envelope { error, message }, diferente do SgrResponse padrão do SGR.
        next: (response: UsuarioExternoResponse) => {
          if (response.error) {
            this.popupService.showError(response.message || 'Falha ao solicitar o link de definição de senha!');
            return;
          }
          this.mensagemEnvio = response.message;
        },
        error: (response: { error?: UsuarioExternoResponse }) => {
          this.popupService.showError(response?.error?.message || 'Falha ao solicitar o link de definição de senha!');
        },
      });
  }
}
